import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { DangerouslySetHtmlContent } from '@redturtle/iovisit-theme/components';

const messages = defineMessages({
  booking_button_label: {
    id: 'Book now',
    defaultMessage: 'Prenota ora!',
  },
  email_label: {
    id: 'email_label',
    defaultMessage: 'Email',
  },
});

interface BookingProps {
  content: object;
}

export const hasBooking = (content) => {
  return (
    content.booking_button_url ||
    content.booking_email_address ||
    content.booking_embed_html ||
    content.booking_box_description
  );
};

const Booking: React.FC<BookingProps> = ({ content }) => {
  const intl = useIntl();

  if (!hasBooking(content)) {
    return null;
  }
  const description = content.booking_box_description;
  const url_label =
    content.booking_button_label ??
    intl.formatMessage(messages.booking_button_label);
  const mail_address =
    content?.booking_email_address &&
    content.booking_email_address.replace('mailto:', '');

  let link = (
    <UniversalLink
      href={content.booking_button_url}
      className="ui button secondary"
    >
      {url_label}
    </UniversalLink>
  );
  if (content.booking_embed_html) {
    link = (
      <DangerouslySetHtmlContent
        html={content.booking_embed_html}
        className="embed-html"
      />
    );
  }

  return (
    <div className="booking">
      {description && <div className="booking-text">{description}</div>}
      {mail_address && (
        <div className="email">
          <span className="label">
            {intl.formatMessage(messages.email_label)}:{' '}
          </span>
          <span className="address">
            <UniversalLink href={mail_address}>{mail_address}</UniversalLink>
          </span>
        </div>
      )}
      {(content.booking_button_url || content.booking_embed_html) && (
        <div className="booking-link">{link}</div>
      )}
    </div>
  );
};

export default Booking;
